import store from '@/states/index.js'

import BudgetManager from '../BudgetManager.vue'

export default [
    {
        path: '/budgetmanager',
        component: BudgetManager,
        name: 'budgetmanager',
        beforeEnter: (to, from, next) => {
            const role = store.getters['auth/getuser']
            if(role.info.role === 3){
                next()
            }else{
                next('/')
            }
            return
        }
    }
]